/* eslint-disable react/no-multi-comp */
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import {
    GREATER_THAN_ZERO_VALIDATOR,
} from '@ratehub/mtg-common';


const ANNUAL_INCOME_FIELD_NAMES = {
    APPLICANT_INCOME: 'yourIncome',
    CO_APPLICANT_INCOME: 'coApplicantIncome',
};

const ANNUAL_INCOME_FIELDS = [
    {
        field: {
            name: ANNUAL_INCOME_FIELD_NAMES.APPLICANT_INCOME,
            type: 'integer',
            validators: [
                GREATER_THAN_ZERO_VALIDATOR,
            ],
        },
        label: (
            <FormattedMessage
                id="mtg-calculators.AffordabilityStepInputs.yourIncomeLabel"
                defaultMessage="Your income"
            />
        ),
        type: 'currency',
    },
    {
        field: {
            name: ANNUAL_INCOME_FIELD_NAMES.CO_APPLICANT_INCOME,
            type: 'integer',
            required: false,
            validators: [
            ],
        },
        label: (
            <FormattedMessage
                id="mtg-calculators.AffordabilityStepInputs.coApplicantIncomeLabel"
                defaultMessage="Co-applicant's income"
            />
        ),
        type: 'currency',
    },
];

const LIVING_COSTS_FIELD_NAMES = {
    PROPERTY_TAX: 'propertyTax',
    CONDO_FEES: 'condoFees',
    HEATING_COSTS: 'heatingCosts',
};

const LIVING_COSTS_FIELDS = [
    {
        field: {
            name: LIVING_COSTS_FIELD_NAMES.PROPERTY_TAX,
            type: 'integer',
            required: false,
            validators: [],
        },
        label: (
            <FormattedMessage
                id="mtg-calculators.AffordabilityStepInputs.propertyTaxLabel"
                defaultMessage="Annual property tax"
            />
        ),
        format: value => (
            <FormattedMessage
                id="mtg-calculators.AffordabilityStepInputs.propertyTaxFormat"
                defaultMessage="{value, number, CAD0}/year in property taxes"
                values={{ value }}
            />
        ),
        type: 'currency',
    },
    {
        field: {
            name: LIVING_COSTS_FIELD_NAMES.CONDO_FEES,
            type: 'integer',
            required: false,
            validators: [],
        },
        label: (
            <FormattedMessage
                id="mtg-calculators.AffordabilityStepInputs.condoFeesLabel"
                defaultMessage="Monthly condo fees"
            />
        ),
        format: value => (
            <FormattedMessage
                id="mtg-calculators.AffordabilityStepInputs.condoFeesFormat"
                defaultMessage="{value, number, CAD0}/month in condo fees"
                values={{ value }}
            />
        ),
        type: 'currency',
        suffix: '/month in condo fees',
    },
    {
        field: {
            name: LIVING_COSTS_FIELD_NAMES.HEATING_COSTS,
            type: 'integer',
            required: false,
            validators: [],
        },
        label: (
            <FormattedMessage
                id="mtg-calculators.AffordabilityStepInputs.heatingCostsLabel"
                defaultMessage="Monthly heating costs"
            />
        ),
        format: value => (
            <FormattedMessage
                id="mtg-calculators.AffordabilityStepInputs.heatingCostsFormat"
                defaultMessage="{value, number, CAD0}/month in heating costs"
                values={{ value }}
            />
        ),
        type: 'currency',
    },
];

const DEBT_PAYMENT_FIELD_NAMES = {
    CREDIT_CARD: 'creditCardPayment',
    CAR: 'carPayment',
    OTHER: 'otherExpenses',
};

const DEBT_PAYMENT_FIELDS = [
    {
        field: {
            name: DEBT_PAYMENT_FIELD_NAMES.CREDIT_CARD,
            type: 'integer',
            required: false,
            validators: [],
        },
        label: (
            <FormattedMessage
                id="mtg-calculators.AffordabilityStepInputs.creditCardPaymentLabel"
                defaultMessage="Credit card debt payment"
            />
        ),
        format: value => (
            <FormattedMessage
                id="mtg-calculators.AffordabilityStepInputs.creditCardPaymentFormat"
                defaultMessage="{value, number, CAD0}/month in credit card debt"
                values={{ value }}
            />
        ),
        type: 'currency',
    },
    {
        field: {
            name: DEBT_PAYMENT_FIELD_NAMES.CAR,
            type: 'integer',
            required: false,
            validators: [],
        },
        label: (
            <FormattedMessage
                id="mtg-calculators.AffordabilityStepInputs.carPaymentLabel"
                defaultMessage="Car payment"
            />
        ),
        format: value => (
            <FormattedMessage
                id="mtg-calculators.AffordabilityStepInputs.carPaymentFormat"
                defaultMessage="{value, number, CAD0}/month in car payments"
                values={{ value }}
            />
        ),
        type: 'currency',
    },
    {
        field: {
            name: DEBT_PAYMENT_FIELD_NAMES.OTHER,
            type: 'integer',
            required: false,
            validators: [],
        },
        label: (
            <FormattedMessage
                id="mtg-calculators.AffordabilityStepInputs.otherExpensesLabel"
                defaultMessage="Other loan expenses"
            />
        ),
        format: value => (
            <FormattedMessage
                id="mtg-calculators.AffordabilityStepInputs.otherExpensesFormat"
                defaultMessage="{value, number, CAD0}/month in loan expenses"
                values={{ value }}
            />
        ),
        type: 'currency',
    },
];


const MESSAGES = defineMessages({
    house: {
        id: 'mtg-calculators.AffordabilityCashNeeded.houseType',
        defaultMessage: 'House',
    },
    condo: {
        id: 'mtg-calculators.AffordabilityCashNeeded.condoType',
        defaultMessage: 'Condo',
    },
});

const HOME_TYPE_OPTIONS = [
    {
        value: 'house',
        label: MESSAGES.house,
    },
    {
        value: 'condo',
        label: MESSAGES.condo,
    },
];

export {
    ANNUAL_INCOME_FIELD_NAMES,
    ANNUAL_INCOME_FIELDS,

    LIVING_COSTS_FIELD_NAMES,
    LIVING_COSTS_FIELDS,

    DEBT_PAYMENT_FIELD_NAMES,
    DEBT_PAYMENT_FIELDS,

    HOME_TYPE_OPTIONS,
};
